// Client V1 lib imports
const businessEvents = require('client/lib/business-events')
const { RequestError } = require('client/lib/request')

function uploader(url, name, file, options) {
  const { csrfToken, method, pageContext, onProgress } = normalizeOptions(options)

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    const captureStackErr = new Error('capture stack')

    xhr.onreadystatechange = event => {
      if (xhr.readyState === XMLHttpRequest.OPENED) {
        onProgress(event, 0)
      }
      if (xhr.readyState === XMLHttpRequest.DONE) {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(xhr.responseText)
        } else {
          const err = RequestError.fromXHR(url, xhr)
          err.stack = captureStackErr.stack
          reject(err)
        }
      }
    }

    xhr.upload.onprogress = event => {
      if (event.lengthComputable) {
        const percentLoaded = (event.loaded / event.total) * 100
        onProgress(event, percentLoaded)
      }
    }

    const formData = new FormData()
    formData.append('_csrf', csrfToken)
    formData.append('_page_context', JSON.stringify(pageContext))
    formData.append(name, file)

    xhr.open(method, url, true)
    xhr.send(formData)
  })
}

function normalizeOptions(options = {}) {
  return {
    csrfToken: app.store.getState().env.csrfToken,
    method: 'POST',
    pageContext: businessEvents.getEventPageContext(options.pageContext),
    onProgress() {},
    ...options
  }
}

module.exports = uploader
